import { useAuth } from 'context/AuthContext';
import { useEffect, useState } from 'react';
import { IoIosClose } from 'react-icons/io';
import { getNews } from 'services/news.service';
import { updateUserProfile } from 'services/profile.service';

import './styles.scss';
import { UserInfo } from 'types/user';

interface Props {
  send: () => void;
  player: UserInfo;
}

export default function NewFeatures(data: Props) {
  const { send, player } = data;
  const [news, setNews] = useState<any>();

  const { user, refreshUser } = useAuth();

  async function handleCloseTutorial() {
    setNews(undefined);
    await updateUserProfile({
      _id: user?._id,
      extra: {
        ...user?.extra,
        lasNews: news?.created,
      },
    });

    refreshUser();
  }

  useEffect(() => {
    async function loadNews() {
      if (user) {
        const data = await getNews(player?.cad_missao, user.extra.lasNews);

        if (data) {
          setNews(data);
        } else {
          send();
        }
      }
    }

    loadNews();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, player]);

  if (!news) return null;

  return (
    <div className="modal-news rb-modal-overlay rb-modal-overlay--top">
      <div className="rb-modal rb-modal--md">
        <button className="rb-modal__close" aria-label="Fechar" onClick={() => handleCloseTutorial()}>
          <IoIosClose size={26} />
        </button>

        {news?.text && <div dangerouslySetInnerHTML={{ __html: news.text }}></div>}
      </div>
    </div>
  );
}
